module.exports = __webpack_public_path__ + "static/media/Sharp 5 R-IGZO Low-Power Performance.890ecc6b.png";